import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nex9pcmkzj: FaireBrandEntity = {
  token: "b_nex9pcmkzj",
  type: "brand",
  name: "Mio Queena",
  avatarUrl:
    "https://cdn.faire.com/fastly/41376ee28ba29996d1e23aab70d18ee7234d145a43c7e191ab895e5689644b13.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0561048f2fe7704af438268bb6453144f90f344c63002fd5b2bc49f38e1553f2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/41376ee28ba29996d1e23aab70d18ee7234d145a43c7e191ab895e5689644b13.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0561048f2fe7704af438268bb6453144f90f344c63002fd5b2bc49f38e1553f2.jpeg",
  location: "Brighton, CO, USA",
  minimumOrderDollars: 55,
  rating: 4.9,
  reviewCount: 1521,
  isTopShop: true,
  isInsider: true,
  description:
    "Update new products daily, please Sort by Newest products. \nFor more products of the same type, please serch relevant keywords and select the newest for sorting and browsing. \nHope you can find products that can create more profits for you.  Thank you!\n\nMio Queena is a contemporary fashion brand dedicated to providing affordable and high-quality jewelry.We want to help you express your individuality without compromising comfort or budget. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:15.916Z",
    importedBy: "entity-db-cli",
  },
};
